
import { ValidationProvider } from 'vee-validate';
import { Form, FormElement, InputText, Note, Select, Toggle } from '05-ui-kit';
import { formatAddress } from '@artmizu/utils';
import { computed, inject, ref } from '@nuxtjs/composition-api';
import { addDays, format, isSameDay, parse, parseISO, toDate } from 'date-fns';
import { ru } from 'date-fns/locale';
import type { PartialDeep } from 'type-fest';
import type { CheckoutDelivery, CheckoutDeliveryDate } from '~/type/Checkout';
import type { CourierAddress, PickupAddress } from '~/type/DeliveryAddress';
import type { NewOrderDelivery } from '~/type/NewOrder';
import type { Location } from '~/type/Location';
import OrderTypeSelect from '~/components/Checkout/OrderTypeSelect/index.vue';
import { useLocationStore } from '~/store/location';
import TSRadioListSelect from '~/components/ts-components/TSRadioListSelect/TSRadioListSelect.vue';
import { useSharedStore } from '~/store/shared';
import type { EmitteryType } from '~/plugins/emitter';
const __sfc_main = {};
__sfc_main.props = {
  list: {
    key: "list",
    required: true,
    type: Array
  },
  value: {
    key: "value",
    required: false,
    type: null
  },
  city: {
    key: "city",
    required: true,
    type: null
  },
  deliveryDate: {
    key: "deliveryDate",
    required: false,
    type: Array
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const emitter = inject<EmitteryType>('emitter')!;
  const {
    isMakhachkala
  } = useLocationStore();
  const cityList = ref<Location[]>([]);
  const sharedStore = useSharedStore();
  function onTypeChange(type: CheckoutDelivery) {
    if (props.value?.type?.id !== type.id) {
      emitter.emit('delivery-select', {
        type: type.title
      });
      onChange({
        id: type.id,
        address: getBlankAddressForCertainType(type)
      });
    }
  }
  function getDate(date: string) {
    const currentDate = format(parse(date, 'yyyy.MM.d', new Date(), {
      locale: ru
    }), 'd MMMM', {
      locale: ru
    });
    return currentDate;
  }
  function getBlankAddressForCertainType(type: CheckoutDelivery) {
    if (type.allowSelectUserAddress && !type.list?.length) return undefined;else if (type.list && type.list?.length > 0) return type.list[0];
  }
  function onChange({
    id = props.value?.type?.id,
    recipientPhone = props.value?.recipientPhone,
    recipient = props.value?.recipient,
    address = props.value?.address,
    deliveryDate = props.value?.deliveryDate,
    deliveryTime = props.value?.deliveryTime
  }: {
    id?: number;
    address?: PartialDeep<CourierAddress> | PartialDeep<PickupAddress>;
    recipientPhone?: string;
    recipient?: string;
    deliveryDate?: string;
    deliveryTime?: string;
  } = {}) {
    const type = props.list.find(el => el.id === id);
    const formatted = type?.allowSelectUserAddress && address?.type === 'courier' && formatAddress(address!);
    if (formatted) address!.formatted = formatted;
    emit('change', {
      type,
      address,
      recipientPhone,
      recipient,
      deliveryDate,
      deliveryTime
    });
  }
  function isActive(id: number) {
    return props.value?.type?.id === id;
  }
  function onCityChange(id: number) {
    const el = cityList.value.find((el: Location) => {
      return el.id === +id;
    });
    if (el) emit('city-change', el);
  }
  function onCityListLoad({
    response
  }: {
    response: {
      result: Location[];
    };
  }) {
    cityList.value = (response.result || []).map(el => ({
      ...el,
      value: el.id
    }));
  }
  const dateIntervals = computed(() => {
    return props.deliveryDate?.map(t => {
      return {
        name: getDate(format(parseISO(t.date), 'yyyy.MM.d')),
        value: t.date,
        subtext: isSameDay(toDate(sharedStore.currentDate || new Date()), parseISO(t.date)) ? 'Сегодня' : isSameDay(addDays(toDate(sharedStore.currentDate || new Date()), 1), parseISO(t.date)) ? 'Завтра' : format(parse(format(parseISO(t.date), 'yyyy.MM.d'), 'yyyy.MM.d', new Date(), {
          locale: ru
        }), 'EEEEEE', {
          locale: ru
        })
      };
    }) || [];
  });
  const selectedInterval = ref(0);
  const timeIntervals = computed(() => {
    return props.deliveryDate?.length ? getTimeIntervals(props.deliveryDate[selectedInterval.value]?.timeIntervals) : undefined;
  });
  function getTimeIntervals(intervals: {
    from: string;
    to: string;
  }[]) {
    return intervals.map((item: {
      from: string;
      to: string;
    }) => {
      return {
        name: `c ${item.from} до ${item.to} ч`,
        value: `${item.from}-${item.to}`
      };
    });
  }
  return {
    emitter,
    isMakhachkala,
    cityList,
    onTypeChange,
    onChange,
    isActive,
    onCityChange,
    onCityListLoad,
    dateIntervals,
    selectedInterval,
    timeIntervals
  };
};
__sfc_main.components = Object.assign({
  Form,
  FormElement,
  Select,
  OrderTypeSelect,
  Note,
  TSRadioListSelect,
  Toggle,
  ValidationProvider,
  InputText
}, __sfc_main.components);
export default __sfc_main;
